import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import Logo from "../../../../assets/icon-128.png";
import { Image, AnimatedText } from "./index.styled";

type Props = {
  text?: string;
};

const LoadingPage = ({ text }: Props) => {
  const loadingText = text || "Attelas";

  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <Image src={Logo} />
      <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
        {loadingText.split("").map((char, index) => {
          if (char === " ") {
            return (
              <Typography key={index} fontSize={18}>
                &nbsp;
              </Typography>
            );
          }
          return (
            <AnimatedText key={index} delay={index * 0.2} fontSize={18} fontWeight={700} color="grey.400">
              {char}
            </AnimatedText>
          );
        })}
      </Box>
    </Stack>
  );
};

export default LoadingPage;
